import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { User } from '../models/user.model';
import { ApiService } from '../http/api.service';

@Injectable({providedIn: 'root'})
export class AuthService {
  private authState = false;

  constructor(
    private apiService: ApiService,
    private router: Router,
  ) {}

  async checkUserLogin(data: User) {
    localStorage.clear();

    const userResponse = await this.apiService.login(data);

    localStorage.setItem('userToken', JSON.stringify(userResponse));
    this.router.navigate(['/company']);
  }

  refreshToken() {
    const token = this.getUserToken();

    return this.apiService.refreshToken(
      { refresh_token: token.refresh_token }
    );
  }

  logout() {
    this.router.navigate(['/auth']);
    localStorage.clear();
  }

  getUserToken() {
    return JSON.parse(localStorage.getItem('userToken'));
  }

  isAuthenticated() {
    const token = this.getUserToken();

    if (token) {
      return this.setUserState(true);
    }

    return this.setUserState(false);
  }

  getUserState() {
    this.isAuthenticated();
    return this.authState;
  }

  setUserState(value: boolean) {
    this.authState = value;
  }

}
